// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warning_button-module__warning--2lMc-{cursor:pointer;outline-style:none;border-radius:2px;text-decoration:none;word-break:keep-all;white-space:nowrap;overflow:hidden;display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;height:40px;min-width:80px;padding:0 16px;font-weight:500;font-size:16px;line-height:24px;letter-spacing:0px;background-color:#da345e;color:#fff}.warning_button-module__warning--2lMc-:hover{background:#c42e54}\n", ""]);
// Exports
exports.locals = {
	"warning": "warning_button-module__warning--2lMc-"
};
module.exports = exports;
